module.exports = __webpack_public_path__ + "static/media/bandera.e5564902.svg";